import { useState, useEffect, useRef } from 'react';
import { InputText } from 'primereact/inputtext';
import { Checkbox } from 'primereact/checkbox';
import { Button } from 'primereact/button';
import { FloatLabel } from 'primereact/floatlabel';
import 'primereact/resources/primereact.min.css';
import 'primereact/resources/themes/lara-light-indigo/theme.css';
import 'primeicons/primeicons.css';
import { ColorPicker } from 'primereact/colorpicker';
import '../../../assets/css/idCardTemplateConfig.css';
import Loader from "../../Shared/Loader/Loader";
import APIConstant from "../../../utils/pathConstants";
import api from "../../../utils/apiClient";
import CommonConfig from '../../../utils/constant';
import Toast from '../../Shared/Toast/Toast';
import { apiBase } from '../../../utils/config';
import { Dialog } from 'primereact/dialog';
import DeleteConfirmation from '../../Dialogs/DeleteConfirmation';
import Result1 from '../../../assets/images/Result1.png';
import { useCatchResponse } from '../../../utils/useCatchResponse';
import UploadFile from '../../UploadFile/UploadFile';
import { Dropdown } from 'primereact/dropdown';

const AddEditResultTemplate = (props) => {
    const { catchResponse } = useCatchResponse();
    const [securityUserID, setSecurityUserID] = useState("");
    const schoolImgUploadRef = useRef(null);
    const waterMarkUploadRef = useRef(null);
    const sealImgUploadRef = useRef(null);
    const backgroundImgUploadRef = useRef(null);
    const signUploadRef = useRef(null);
    const [titleName, setTitleName] = useState('');
    const [titleNameErr, setTitleNameErr] = useState(false);
    const [titleNameErrText, setTitleNameErrText] = useState('');
    const [principalSignLogo, setPrincipalSignLogo] = useState(null);
    const [previewPrincipalSignLogo, setPreviewPrincipalSignLogo] = useState(null);
    const [schoolLogo, setSchoolLogo] = useState(null);
    const [previewSchoolLogo, setPreviewSchoolLogo] = useState(null);
    const [waterMarkLogo, setWaterMarkLogo] = useState(null);
    const [previewWaterMarkLogo, setPreviewWaterMarkLogo] = useState(null);
    const [isDeleteConfirmation, setIsDeleteConfirmation] = useState(false);
    const [bodyoptionsList, setBodyoptionsList] = useState([]);
    const [selectedBodyOptions, setSelectedBodyOptions] = useState([]);
    const [footerOptionsList, setFooterOptionsList] = useState([]);
    const [selectedFooterOptions, setSelectedFooterOptions] = useState([]);
    const [selectedTemplate, setSelectedTemplate] = useState('/static/media/Result1.ccfa70caf758e10f3b11.png');
    const [editingIndex, setEditingIndex] = useState(null);
    const [newOptionValue, setNewOptionValue] = useState("");
    const [modelType, setModelType] = useState('');
    const [sealLogo, setSealLogo] = useState(null);
    const [previewSealLogo, setPreviewSealLogo] = useState(null);
    const [isMarksAllowed, setIsMarksAllowed] = useState(false);
    const [isRankByType, setIsRankByType] = useState(true);
    const [isShowTerm, setIsShowTerm] = useState(true);
    const [isShowCoscholastic, setIsShowCoscholastic] = useState(true);
    const [backGroundImage, setBackGroundImage] = useState(null);
    const [previewBackGroundImage, setPreviewBackGroundImage] = useState(null);
    const [nameType, setNameType] = useState('FirstSurname');
    const submitButtonRef = useRef(null);
    const titleNameRef = useRef(null);
    const uploadContainerRef = useRef(null);
    const [borderColor, setBorderColor] = useState('');
    const nameTypeList = [
        { label: 'First Name/Surname', value: 'FirstSurname' },
        { label: 'Surname/First Name', value: 'SurnameFirstName' },
        { label: 'First Name/Father Name/Surname', value: 'FirstFatherNameSurname' },
        { label: 'Surname/First Name/Father Name', value: 'SurnameFirstFatherName' },
        { label: 'First Name/Mother Name/Surname', value: 'FirstMotherNameSurname' },
        { label: 'Surname/First Name/Mother Name', value: 'SurnameFirstMotherName' },
    ];

    useEffect(() => {
        uploadContainerRef.current?.focus();
    }, []);
    useEffect(() => {
        const loginData = CommonConfig.loginData();
        setSecurityUserID(loginData?._id);
        setTimeout(() => {
            titleNameRef.current?.focus();
        }, 100);
    }, []);


    useEffect(() => {
        const loginData = CommonConfig.loginData();
        setSecurityUserID(loginData?._id);
        let bodyList = [
            { label: 'Class', value: 'Class' },
            { label: 'Section', value: 'Section' },
            { label: 'Board', value: 'Board' },
            { label: 'Medium', value: 'Medium' },
            { label: 'Academic Year', value: 'AcademicYear' },
            { label: 'Student Name', value: 'StudentName' },
            { label: 'Student Photo', value: 'StudentPhoto' },
            { label: 'Father Name', value: 'FName' },
            { label: 'Mother Name', value: 'MName' },
            { label: 'Date of Birth', value: 'DOB' },
            { label: 'Address', value: 'Address' },
            { label: 'Roll No', value: 'RollNo' },
            { label: 'GRNo', value: 'GRNo' }
        ];
        let footerList = [
            { label: 'Marks', value: 'Marks' },
            { label: 'Attendance', value: 'Attendance' },
            { label: 'Percentage', value: 'Percentage' },
            { label: 'Remarks', value: 'Remarks' },
            { label: 'Grade', value: 'Grade' },
            { label: 'Rank', value: 'Rank' },
            { label: 'School Address', value: 'SCLAddress' },
            { label: 'School Phone', value: 'SCLPhone' },
            { label: 'School Email', value: 'SCLEmail' },

        ];
        if (props?.configId) {
            setTitleName(props?.masterData?.TitleName);
            setSelectedTemplate(props?.masterData?.TemplateName ?? selectedTemplate);
            setSelectedBodyOptions(props?.masterData?.BodySection
                ? props?.masterData?.BodySection.map((item) => {
                    return item?.key;
                })
                : []);
            setBodyoptionsList(bodyList);
            setSelectedFooterOptions(props?.masterData?.FooterSection
                ? props?.masterData?.FooterSection.map((item) => {
                    return item?.key;
                })
                : []);
            setFooterOptionsList(footerList);
            setPrincipalSignLogo(props?.masterData?.PrincipalSignImage ? `${apiBase}/Documents/${props?.masterData?.PrincipalSignImage}` : null);
            setSchoolLogo(props?.masterData?.SchoolLogo ? `${apiBase}/Documents/${props?.masterData?.SchoolLogo}` : null);
            setSealLogo(props?.masterData?.SealImage ? `${apiBase}/Documents/${props?.masterData?.SealImage}` : null);
            setBackGroundImage(props?.masterData?.BackgroundImage ? `${apiBase}/Documents/${props?.masterData?.BackgroundImage}` : null);
            setWaterMarkLogo(props?.masterData?.WaterMarkImage ? `${apiBase}/Documents/${props?.masterData?.WaterMarkImage}` : null);
            setIsMarksAllowed(props?.masterData?.IsMarksAllowed);
            setBorderColor(props?.masterData?.BorderColor ?? '');
            setIsRankByType(props?.masterData?.IsRankByType ?? true);
            setIsShowTerm(props?.masterData?.IsShowTerm ?? true);
            setIsShowCoscholastic(props?.masterData?.IsShowCoscholastic);
            setNameType(props?.masterData?.NameType || 'FirstSurname');
        } else {
            setBodyoptionsList(bodyList);
            setFooterOptionsList(footerList);
        }
    }, []);

    const validate = () => {
        let formIsValid = true;
        if (CommonConfig.isEmpty(titleName)) {
            formIsValid = false;
            setTitleNameErr(true);
            setTitleNameErrText("Title Name is required");
        } else {
            setTitleNameErr(false);
            setTitleNameErrText("");
        }
        return formIsValid;
    };

    const onCancel = () => {
        props.onCancel();
    }

    const AddUpdateTemplate = async (e) => {
        if (validate(e)) {
            try {
                let bodySectionData = [];
                if (selectedBodyOptions) {
                    bodySectionData = selectedBodyOptions.map((x, idx) => {
                        return {
                            label: bodyoptionsList.filter(y => y?.value === x)[0]?.label,
                            key: x
                        }
                    })
                }
                let footerSectionData = [];
                if (selectedFooterOptions) {
                    footerSectionData = selectedFooterOptions.map((x, idx) => {
                        return {
                            label: footerOptionsList.filter(y => y?.value === x)[0]?.label,
                            key: x
                        }
                    })
                }
                const formData = new FormData();
                formData.append("id", props?.masterData?._id ?? '');
                formData.append('TemplateName', selectedTemplate);
                formData.append("TitleName", titleName);
                formData.append("BodySection", JSON.stringify(bodySectionData));
                formData.append("NameType", nameType);
                formData.append("FooterSection", JSON.stringify(footerSectionData));
                formData.append("IsMarksAllowed", JSON.stringify(isMarksAllowed));
                formData.append("IsRankByType", !CommonConfig.isEmpty(isRankByType) ? isRankByType : true);
                formData.append("IsShowTerm", !CommonConfig.isEmpty(isShowTerm) ? isShowTerm : true);
                formData.append("IsShowCoscholastic", !CommonConfig.isEmpty(isShowCoscholastic) ? isShowCoscholastic : true);
                formData.append("BorderColor", borderColor ?? '');
                formData.append("CreatedBy", securityUserID);
                if (principalSignLogo && principalSignLogo.type) {
                    formData.append("PrincipalSignImage", principalSignLogo);
                } else if (CommonConfig.isEmpty(principalSignLogo)) {
                    formData.append("PrincipalSignImage", '');
                }
                if (schoolLogo && schoolLogo.type) {
                    formData.append("SchoolLogo", schoolLogo);
                } else if (CommonConfig.isEmpty(schoolLogo)) {
                    formData.append("SchoolLogo", '');
                }
                if (sealLogo && sealLogo.type) {
                    formData.append("SealImage", sealLogo);
                } else if (CommonConfig.isEmpty(sealLogo)) {
                    formData.append("SealImage", '');
                }
                if (backGroundImage && backGroundImage.type) {
                    formData.append("BackgroundImage", backGroundImage);
                } else if (CommonConfig.isEmpty(backGroundImage)) {
                    formData.append("BackgroundImage", '');
                }
                if (waterMarkLogo && waterMarkLogo.type) {
                    formData.append("WaterMarkImage", waterMarkLogo);
                } else if (CommonConfig.isEmpty(waterMarkLogo)) {
                    formData.append("WaterMarkImage", '');
                }
                Loader.show();
                await api
                    .post(APIConstant.path.AddUpdateResultConfiguration, formData, {
                        headers: {
                            "Content-Type": "multipart/form-data",
                        },
                    })
                    .then((response) => {
                        let res = response;
                        if (res.success) {
                            Toast.success({ message: res.message });
                            Loader.hide();
                            onCancel();
                        } else {
                            Toast.error({ message: res.message });
                            Loader.hide();
                            onCancel();
                        }
                    })
                    .catch((err) => {
                        console.log(err);
                        Toast.error({ message: err?.data?.message });
                        Loader.hide();
                        onCancel();
                    });
            } catch (err) {
                console.log(err);
                Toast.error({ message: err });
                Loader.hide();
                onCancel();
                catchResponse(err);
            }
        }
    };

    const handlePrincipalSignLogo = (e) => {
        const selectedFile = e.files[0];
        if (selectedFile) {
            const img = new Image();
            img.onload = () => {
                if (img.width === img.height) {
                    setPrincipalSignLogo(selectedFile);
                    const fileURL = URL.createObjectURL(selectedFile);
                    setPreviewPrincipalSignLogo(fileURL);
                } else {
                    if (signUploadRef.current) {
                        signUploadRef.current.clear();
                    }
                    Toast.error({ message: 'The image must have a 1:1 aspect ratio.' });
                }
            };
            img.onerror = () => {
                if (signUploadRef.current) {
                    signUploadRef.current.clear();
                }
                Toast.error({ message: 'Error loading the image.' });
            };

            const reader = new FileReader();
            reader.onload = (event) => {
                img.src = event.target.result;
            };
            reader.readAsDataURL(selectedFile);
        }
    };

    const handleSealLogo = (e) => {
        const selectedFile = e.files[0];
        if (selectedFile) {
            const img = new Image();
            img.onload = () => {
                if (img.width === img.height) {
                    setSealLogo(selectedFile);
                    const fileURL = URL.createObjectURL(selectedFile);
                    setPreviewSealLogo(fileURL);
                } else {
                    if (sealImgUploadRef.current) {
                        sealImgUploadRef.current.clear();
                    }
                    Toast.error({ message: 'The image must have a 1:1 aspect ratio.' });
                }
            };
            img.onerror = () => {
                if (sealImgUploadRef.current) {
                    sealImgUploadRef.current.clear();
                }
                Toast.error({ message: 'Error loading the image.' });
            };

            const reader = new FileReader();
            reader.onload = (event) => {
                img.src = event.target.result;
            };
            reader.readAsDataURL(selectedFile);
        }
    };

    const handleSchoolLogo = (e) => {
        const selectedFile = e.files[0];
        if (!selectedFile) return;
        const img = new Image();
        img.onload = async () => {
            const aspectRatio = img.width / img.height;
            const expectedRatio = 1 / 1;
            const tolerance = 0.01;

            if (Math.abs(aspectRatio - expectedRatio) > tolerance) {
                if (schoolImgUploadRef.current) {
                    schoolImgUploadRef.current.clear();
                }
                Toast.error({ message: 'The image must have a 1:1 aspect ratio.' });
                return;
            }
            setSchoolLogo(selectedFile);
            const fileURL = URL.createObjectURL(selectedFile);
            setPreviewSchoolLogo(fileURL);
        };

        img.onerror = () => {
            if (schoolImgUploadRef.current) {
                schoolImgUploadRef.current.clear();
            }
            Toast.error({ message: 'Error loading the image.' });
        };

        const reader = new FileReader();
        reader.onload = (event) => {
            img.src = event.target.result;
        };
        reader.readAsDataURL(selectedFile);
    };

    const handleWaterMarkLogo = (e) => {
        const selectedFile = e.files[0];
        if (!selectedFile) return;
        const img = new Image();
        img.onload = async () => {
            const aspectRatio = img.width / img.height;
            const expectedRatio = 1 / 1;
            const tolerance = 0.01;

            if (Math.abs(aspectRatio - expectedRatio) > tolerance) {
                if (waterMarkUploadRef.current) {
                    waterMarkUploadRef.current.clear();
                }
                Toast.error({ message: 'The image must have a 1:1 aspect ratio.' });
                return;
            }
            setWaterMarkLogo(selectedFile);
            const fileURL = URL.createObjectURL(selectedFile);
            setPreviewWaterMarkLogo(fileURL);
        };

        img.onerror = () => {
            if (waterMarkUploadRef.current) {
                waterMarkUploadRef.current.clear();
            }
            Toast.error({ message: 'Error loading the image.' });
        };

        const reader = new FileReader();
        reader.onload = (event) => {
            img.src = event.target.result;
        };
        reader.readAsDataURL(selectedFile);
    };

    const handleBackgroundImage = (e) => {
        const selectedFile = e.files[0];
        if (selectedFile) {
            const img = new Image();
            img.onload = () => {
                const aspectRatio = img.width / img.height;
                const expectedRatio = 6 / 1;
                const tolerance = 0.01;

                if (Math.abs(aspectRatio - expectedRatio) > tolerance) {
                    if (backgroundImgUploadRef.current) {
                        backgroundImgUploadRef.current.clear();
                    }
                    Toast.error({ message: 'The image must have a 6:1 aspect ratio.' });
                    return;
                }
                setBackGroundImage(selectedFile);
                const fileURL = URL.createObjectURL(selectedFile);
                setPreviewBackGroundImage(fileURL);

            };
            img.onerror = () => {
                if (backgroundImgUploadRef.current) {
                    backgroundImgUploadRef.current.clear();
                }
                Toast.error({ message: 'Error loading the image.' });
            };
            const reader = new FileReader();
            reader.onload = (event) => {
                img.src = event.target.result;
            };
            reader.readAsDataURL(selectedFile);
        }
    };

    const renderFooter = () => (
        <div className="dialog-footer p-d-flex p-ai-center p-jc-end">
            <Button
                label="Cancel"
                className="btn-text-action-secondary"
                onClick={handleClose}
            />
            <Button
                label="Delete"
                className="btn-text-action-primary"
                onClick={() => {
                    handleClose();
                    if (modelType === 'Sign') {
                        if (signUploadRef.current) {
                            signUploadRef.current.clear();
                        }
                        setPrincipalSignLogo("")
                        setPreviewPrincipalSignLogo();
                    } else if (modelType === 'Seal') {
                        if (sealImgUploadRef.current) {
                            sealImgUploadRef.current.clear();
                        }
                        setSealLogo("")
                        setPreviewSealLogo();
                    } else if (modelType === 'School Stamp') {
                        if (schoolImgUploadRef.current) {
                            schoolImgUploadRef.current.clear();
                        }
                        setSchoolLogo("")
                        setPreviewSchoolLogo();
                    } else if (modelType === 'Water Mark') {
                        if (waterMarkUploadRef.current) {
                            waterMarkUploadRef.current.clear();
                        }
                        setWaterMarkLogo("")
                        setPreviewWaterMarkLogo();
                    } else {
                        if (backgroundImgUploadRef.current) {
                            backgroundImgUploadRef.current.clear();
                        }
                        setBackGroundImage("")
                        setPreviewBackGroundImage();
                    }
                }}
            />
        </div>
    );

    const handleClose = () => {
        setIsDeleteConfirmation(false)
    };

    const startEditing = (index, currentValue) => {
        setEditingIndex(index);
        setNewOptionValue(currentValue);
    };

    const saveEdit = (index, type) => {
        if (type === 'Body') {
            setBodyoptionsList((prev) =>
                prev.map((option, i) =>
                    i === index ? { ...option, label: newOptionValue } : option
                )
            );
        } else {
            setFooterOptionsList((prev) =>
                prev.map((option, i) =>
                    i === index ? { ...option, label: newOptionValue } : option
                )
            );
        }
        setEditingIndex(null);
        setNewOptionValue("");
    };

    const cancelEdit = () => {
        setEditingIndex(null);
        setNewOptionValue("");
    };

    const handleCheckBodyboxChange = (e) => {
        const value = e.value;
        setSelectedBodyOptions((prevSelected) =>
            prevSelected.includes(value)
                ? prevSelected.filter((v) => v !== value)
                : [...prevSelected, value]
        );
    };

    const handleCheckFooterboxChange = (e) => {
        const value = e.value;
        setSelectedFooterOptions((prevSelected) =>
            prevSelected.includes(value)
                ? prevSelected.filter((v) => v !== value)
                : [...prevSelected, value]
        );
    };

    const handleImageClick = (image) => {
        if (selectedTemplate === image) {
            setSelectedTemplate('');
        } else {
            setSelectedTemplate(image);
        }
    };

    const handleDelete = (type) => {
        setIsDeleteConfirmation(true);
        setModelType(type);
    };

    const renderFileUpload = (label, note, preview, original, uploadHandler, uploadRef, aspectRatio) => (
        <UploadFile label={label} note={note} preview={preview} original={original} uploadHandler={uploadHandler} uploadRef={uploadRef} handleDelete={handleDelete} isEditAllow={true} aspectRatio={aspectRatio} />
    );


    const OptionItem = ({ option, index, editingIndex, selectedOptions, newOptionValue, handleCheckChange, startEditing, setNewOptionValue, saveEdit, cancelEdit, section }) => (
        <div className="p-d-flex p-jc-between p-my-2">
            <div className="p-d-flex p-ai-center">
                <Checkbox
                    inputId={option.value}
                    value={option.value}
                    onChange={handleCheckChange}
                    checked={selectedOptions.includes(option.value)}
                    className="p-mr-2"
                />
                {editingIndex === index ? (
                    <div className='p-w-100'>
                        <div className='custom-inputs'>
                            <InputText
                                value={newOptionValue || option.label}
                                onChange={(e) => setNewOptionValue(e.target.value)}
                                placeholder="Enter new value"
                                className="p-mr-2"
                            />
                        </div>
                        {option?.value === 'StudentName' &&
                            <Dropdown className='p-pl-2 p-mt-0' value={nameType} options={nameTypeList} onChange={(e) => setNameType(e.value)} placeholder="Select value" filter
                                showClear />}
                    </div>
                ) : (
                    <label htmlFor={option.value} className="p-mr-2">{option.label}</label>
                )}
            </div>
            {option.value !== 'StudentPhoto' && (
                editingIndex === index ? (
                    <div className="p-d-flex p-ai-center">
                        <Button icon="pi pi-check" className="e-border-btn" onClick={() => saveEdit(index, section)} />
                        <Button icon="pi pi-times" className="e-border-btn p-ml-2" onClick={cancelEdit} />
                    </div>
                ) : <Button className="e-border-btn" icon="pi pi-pencil" onClick={() => startEditing(index, option.label)} />
            )}
        </div>
    );

    const OptionGrid = ({ optionsList, section, ...props }) => (
        optionsList.map((option, index) => (
            <OptionItem
                key={option.value}
                option={option}
                index={index}
                section={section}
                {...props}
                {...option.value === 'StudentName' &&
                <Dropdown className='p-pl-2 p-mt-0' value={nameType} options={nameTypeList} onChange={(e) => setNameType(e.value)} placeholder="Select value" filter
                    showClear />}
            />
        ))
    );

    const handleColorChange = (value, type) => {
        setBorderColor(value);
    };

    const handleInputChange = (value, type) => {
        let inputValue = value?.trim();
        const alphanumericValue = inputValue.replace(/[^a-zA-Z0-9\s]/g, '');

        setBorderColor(alphanumericValue);
    };

    return (
        <div className="template-config-container">
            <div className='template-body'>
                <div className="image-selection-container">
                    {[Result1].map((image, index) => (
                        <img
                            src={image}
                            key={index}
                            alt={`IdCard${index + 1}`}
                            className={`image-item ${selectedTemplate === image ? 'selected' : ''}`}
                            onClick={() => handleImageClick(image)}
                            style={{
                                borderColor: selectedTemplate === image ? '#1c515e' : 'transparent',
                            }}
                        >
                        </img>
                    ))}
                </div>
                <div className='section-box'>
                    <h2>Title</h2>
                    <div className='p-grid'>
                        <div className="p-col-12 p-md-5 ">
                            <div className='custom-inputs'>
                                <label htmlFor="titleName">Title Name</label>
                                <FloatLabel>
                                    <InputText
                                        ref={titleNameRef}
                                        className='p-mt-1 p-w-100'
                                        id="titleName"
                                        value={titleName}
                                        onChange={(e) => setTitleName(e.target.value)}
                                        style={{
                                            fontFamily: "Noto Sans, Arial, sans-serif"
                                        }}
                                    />
                                </FloatLabel>
                            </div>
                            <span className="error-msg" style={{ color: 'red' }}>
                                {titleNameErr ? titleNameErrText : null}
                            </span>
                        </div>
                        <div className="p-col-12 p-md-7">
                            <div className="p-field-checkbox p-mr-2 p-mb-0 p-mt-5 p-pt-1">
                                <Checkbox
                                    inputId="isMarksAllowed"
                                    checked={isMarksAllowed}
                                    onChange={(e) => setIsMarksAllowed(e.checked)}
                                />
                                <label htmlFor='isMarksAllowed'>Marks lessthan 33% not added in overall?</label>
                            </div>
                        </div>
                        <div className="p-col-12 p-md-5 ">
                            <div className="p-field-checkbox">
                                <Checkbox
                                    inputId="isRankByType"
                                    checked={isRankByType}
                                    onChange={(e) => setIsRankByType(e.checked)}
                                />
                                <label htmlFor='isRankByType'>Rank By Class</label>
                            </div>
                        </div>
                        <div className="p-col-12 p-md-7">
                            <Checkbox
                                inputId="isRankByType"
                                checked={!isRankByType}
                                onChange={(e) => setIsRankByType(e.checked)}
                            />
                            <label htmlFor='isRankByType'>Rank By Section</label>
                        </div>
                        <div className="p-col-12 p-md-5 ">
                            <div className="p-field-checkbox">
                                <Checkbox
                                    inputId="isShowTerm"
                                    checked={isShowTerm}
                                    onChange={(e) => setIsShowTerm(e.checked)}
                                />
                                <label htmlFor='isShowTerm'>Show Term</label>
                            </div>
                        </div>
                         <div className="p-col-12 p-md-5 ">
                            <div className="p-field-checkbox">
                                <Checkbox
                                    inputId="isShowCoscholastic"
                                    checked={isShowCoscholastic}
                                    onChange={(e) => setIsShowCoscholastic(e.checked)}
                                />
                                <label htmlFor='isShowCoscholastic'>Show Co-scholastic</label>
                            </div>
                        </div>
                        <div className="p-col-12 p-md-7">
                            <div className='custom-inputs password-field'>
                                <label htmlFor='borderColor'>Border Color</label>
                                <InputText
                                    className="p-mt-2 p-w-100"
                                    value={borderColor.toUpperCase()}
                                    onChange={(e) => handleInputChange(e.target.value, 'BorderColor')}
                                    maxLength={8}
                                />
                                <div className='absolute-icons'>
                                    <ColorPicker
                                        value={borderColor.replace("#", "")}
                                        onChange={(e) => handleColorChange(e.value, 'BorderColor')}
                                        className='tailer-icon'
                                    />
                                </div>
                            </div>
                        </div>
                        <div className="p-d-flex p-ai-center p-jc-between p-mt-2 p-mb-6" style={{ height: 180 }}>
                            {renderFileUpload("Header Image", '(Select 6:1 ratio image)', previewBackGroundImage, backGroundImage, handleBackgroundImage, backgroundImgUploadRef, 6 / 1)}
                            {renderFileUpload("Water Mark", '(Select 1:1 ratio image)', previewWaterMarkLogo, waterMarkLogo, handleWaterMarkLogo, waterMarkUploadRef, 1 / 1)}
                        </div>
                    </div>
                </div>
                <div className='section-box'>
                    <h2>Body Section</h2>
                    <div >
                        <OptionGrid
                            optionsList={bodyoptionsList}
                            section="Body"
                            editingIndex={editingIndex}
                            selectedOptions={selectedBodyOptions}
                            newOptionValue={newOptionValue}
                            handleCheckChange={handleCheckBodyboxChange}
                            startEditing={startEditing}
                            setNewOptionValue={setNewOptionValue}
                            saveEdit={saveEdit}
                            cancelEdit={cancelEdit}
                        />
                    </div>
                </div>
                <div className='section-box'>
                    <h2>Footer Section</h2>
                    <div >
                        <OptionGrid
                            optionsList={footerOptionsList}
                            section="Footer"
                            editingIndex={editingIndex}
                            selectedOptions={selectedFooterOptions}
                            newOptionValue={newOptionValue}
                            handleCheckChange={handleCheckFooterboxChange}
                            startEditing={startEditing}
                            setNewOptionValue={setNewOptionValue}
                            saveEdit={saveEdit}
                            cancelEdit={cancelEdit}
                        />
                    </div>
                    <div className="p-d-flex p-ai-center p-jc-between p-mx-4 p-mt-4">
                        {renderFileUpload("School Stamp", '(Select 1:1 ratio image)', previewSchoolLogo, schoolLogo, handleSchoolLogo, schoolImgUploadRef, 1 / 1)}
                        {renderFileUpload("Seal", '(Select 1:1 ratio image)', previewSealLogo, sealLogo, handleSealLogo, sealImgUploadRef, 1 / 1)}
                        {renderFileUpload("Sign", '(Select 1:1 ratio image)', previewPrincipalSignLogo, principalSignLogo, handlePrincipalSignLogo, signUploadRef, 1 / 1)}                    </div>
                </div>
            </div>
            <div className="dialog-footer p-mx-2">
                <Button className='btn-text-action-secondary' label="Cancel" onClick={(e) => onCancel()} />
                <Button ref={submitButtonRef} label="Save" className="btn-text-action-primary" onClick={(e) => AddUpdateTemplate()} />
            </div>
            <Dialog
                visible={isDeleteConfirmation}
                onHide={handleClose}
                header={
                    <div className="p-d-flex p-jc-between p-ai-center">
                        <span>Delete Confirmation</span>
                    </div>
                }
                footer={renderFooter()}
                draggable={false}
                dismissableMask
                position="center"
                style={{ width: '450px' }}
            >
                <DeleteConfirmation />
            </Dialog>
        </div >
    );
};

export default AddEditResultTemplate;
